{
  "auth.login.email.error_format": "Veuillez entrer une adresse courriel valide",
  "auth.login.email.label": "Courriel",
  "auth.login.email.placeholder": "Courriel",
  "auth.login.forgot_password": "Mot de passe oublié?",
  "auth.login.log_in": "Connexion",
  "auth.login.password.label": "Mot de passe",
  "auth.login.password.placeholder": "Mot de passe",
  "auth.login.password.required": "Mot de passe requis"
}
